import { render, staticRenderFns } from "./Privacy2.vue?vue&type=template&id=67628b28&scoped=true"
var script = {}
import style0 from "./Privacy2.vue?vue&type=style&index=0&id=67628b28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67628b28",
  null
  
)

export default component.exports